import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(10,0,0,10,0,0)" }, [
      _createElementVNode("g", null, [
        _createElementVNode("circle", {
          cx: "5.92",
          cy: "5.92",
          r: "5.42",
          style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}
        }),
        _createElementVNode("line", {
          x1: "13.5",
          y1: "13.5",
          x2: "9.75",
          y2: "9.75",
          style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }